export default "__VITE_ASSET__41a9c3d3__"